export default function () {
    return {
        showFilter: false,
        refs: {
            body: document.body
        },
        init() {
            window.require(['matchMedia'], (mediaCheck) => {
                mediaCheck({
                    media: '(min-width: 1024px)',
                    entry: () => {
                        this.showFilter = false;
                        this.bodyToggleClass(false);
                    }
                });
            });
        },
        toggleFilter() {
            this.showFilter = !this.showFilter;
            this.bodyToggleClass(this.showFilter);
        },
        bodyToggleClass(isActive) {
            if (isActive) {
                this.refs.body.classList.add('_has-modal');
            } else {
                this.refs.body.classList.remove('_has-modal');
            }
        },
        getImageWidth() {
            const image = document.querySelector('.img-inspiration');

            if (image) {
                return image.naturalWidth;
            }
            return 0;
        },
        wrapperImageStyle() {
            return { width: '100%', maxWidth: `${this.getImageWidth()}px` };
        },
        renderMarkerItemStyle({ top, left, elImg }) {
            const image = document.querySelector(elImg);
            const topPercent = (top / image.naturalHeight) * 100;
            const lefPercent = (left / image.naturalWidth) * 100;

            return { left: `${lefPercent}%`, top: `${topPercent}%` };
        }
    };
}
